module.exports = __webpack_public_path__ + "static/media/Sandor Clegane 1.58f32684.jpg";